export const DETAILS_PAGE_TABS = {
  BOOKING: 'booking',
  DETAILS: 'details',
  LOGS: 'logs',
  GROUP_DETAILS: 'group_details',
  ACTIVITY: 'activity',
}

export const PERCENTAGE_FEE_TYPE = 2

export const PROPERTY_GDS_PRICES_UNAVAILABLE = 1501

export const PROPERTY_AVAILABILITY_STATUSES = {
  available: {
    value: 'available',
    color: '#53C249',
    label: 'Available',
  },
  unavailable: {
    value: 'unavailable',
    color: 'rgb(243, 103, 103)',
    label: 'Unavailable',
  },
  in_progress: {
    value: 'in_progress',
    color: 'rgb(0, 122, 255)',
    label: 'In Progress',
  },
}
export const availabilityStatuses = Object.values(
  PROPERTY_AVAILABILITY_STATUSES
)
export type AvailabilityStatus = (typeof availabilityStatuses)[number]['value']

export const DEFAULT_BOOKING_PHONE = '+442080394009'

export const ALTERNATIVE_UNIT_TYPE_CONSIDERED_OPTIONS = [
  { value: 'hotel_room', label: 'Hotel room' },
  { value: 'studio', label: 'Studio' },
  { value: 'one_bedroom', label: '1 Bedroom' },
  { value: 'two_bedrooms', label: '2 Bedrooms' },
  { value: 'three_bedrooms', label: '3 Bedrooms' },
  { value: 'four_bedrooms', label: '4 Bedrooms' },
  { value: 'five_bedrooms', label: '5 Bedrooms' },
]

export const ALTERNATIVE_UNIT_TYPE_TO_UNIT_TYPE = {
  hotel_room: -1,
  studio: 0,
  one_bedroom: 1,
  two_bedrooms: 2,
  three_bedrooms: 3,
  four_bedrooms: 4,
  five_bedrooms: 5,
}

export const REQUEST_HOUSEKEEPING_OPTIONS = [
  { value: 'Once a week', label: 'Weekly' },
  { value: 'Once every two weeks', label: 'Bi-weekly' },
  { value: 'Daily', label: 'Daily' },
  { value: 'Not included', label: 'Not included' },
]

export const TYPE_OF_COMMUTE_OPTIONS = [
  { value: 'walking', label: 'Walking' },
  { value: 'driving', label: 'Driving' },
  { value: 'public_transport', label: 'Public Transport' },
]

export const COMMUTE_TIME_OPTIONS = [
  { value: 'within_10_min', label: 'Within 10 min' },
  { value: 'within_20_min', label: 'Within 20 min' },
  { value: 'within_30_min', label: 'Within 30 min' },
  { value: 'within_45_min', label: 'Within 45 min' },
  { value: 'within_1_hour', label: 'Within 1 hour' },
]

export const CANCELLATION_POLICY_OPTIONS = [
  { value: 'twenty_four_hours', label: '24hrs' },
  { value: 'three_days', label: '3 days' },
  { value: 'seven_days', label: '7 days' },
  { value: 'fourteen_days', label: '14 days' },
  { value: 'thirty_days', label: '30 days' },
  { value: 'not_possible', label: 'Cancellation not possible' },
]

export const IN_HOUSE_CANCELLATION_OPTIONS = [
  { value: 'thirty_days', label: '30 days' },
  { value: 'fourteen_days', label: '14 days' },
  { value: 'seven_days', label: '7 days' },
  { value: 'not_refundable', label: 'Not refundable' },
]

export const MONTH_TO_MONTH_LEASE_OPTIONS = [
  { value: 'sixty_days_ntv', label: '60 days NTV' },
  { value: 'thirty_days_ntv', label: '30 days NTV' },
  { value: 'fifteen_days_ntv', label: '15 days NTV' },
  { value: 'fourteen_days_ntv', label: '14 days NTV' },
]

export const AIRPORT_TRANSFER_OPTIONS = [
  { value: 'paidByGuest', label: 'Guest' },
  { value: 'paidByCompany', label: 'Company' },
]

export const PWC_COMPANY_NAME = 'PWC'
export const PWC_TYPE = 'pwc_hor'
export const PWC_TYPE_GHOR = 'pwc_group_hor'

export const DNV_ENTITY_COMPANY_SLUGS = [
  'dnv-commuterassignment',
  'dnv-lta',
  'dnv-sta',
  'dnv-training-knowledge-booster',
]

export const RIVERSIDE_SLUGS = [
  'riverside-group',
  'riverside-scotland',
  'evolve',
  'ohg',
  'development-london',
  'rho',
  'trg',
]

export const COUPANG_SLUGS = [
  'coupang',
  'coupang1',
  'coupang2',
  'coupang3',
  'coupang4',
  'coupang5',
  'coupang6',
  'coupang7',
  'coupang8',
  'coupang9',
  'coupang10',
  'coupang11',
  'coupang12',
  'coupang13',
  'coupang14',
  'coupang15',
]
